import React, { useEffect, useRef } from 'react';
import { StyleSheet, Animated, TouchableOpacity } from 'react-native';

import { Box } from '@components/Restyle/index';
import Text from '@components/Restyle/Text';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type DeleteFailedToastProps = {
  duration: number;
  onPress?: () => void;
  title: string;
  message?: string;
  width?: number;
};

export const DeleteFailedToast: React.FC<DeleteFailedToastProps> = ({
  duration,
  onPress,
  title,
  message,
  width = 240,
}) => {
  const progressAnim = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.timing(progressAnim, {
      toValue: 1,
      duration: duration,
      useNativeDriver: false,
    }).start();
  }, [progressAnim, duration]);

  const handlePress = () => {
    onPress?.();
  };

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={handlePress}
      accessibilityLabel={message}
      style={[styles.toastContainer, { width: width }]}>
      <Box
        flex={1}
        flexDirection='row'
        height={76}
        alignItems='center'
        justifyContent='center'>
        <Icon
          marginRight='s'
          name='AlertTriangle'
          height={24}
          width={24}
          color='white'
        />
        <Box>
          <Text variant='heading2' color='white'>
            {title}
          </Text>
          <Text
            numberOfLines={1}
            ellipsizeMode='tail'
            variant='webBody'
            color='white'>
            {(message ?? '').length <= 25
              ? message
              : message?.substring(0, 24) + '...'}
          </Text>
        </Box>
      </Box>

      <Animated.View
        style={[
          styles.progressBar,
          {
            width: progressAnim.interpolate({
              inputRange: [0, 1],
              outputRange: ['0%', '100%'],
            }),
          },
        ]}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  toastContainer: {
    height: 80,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
    borderRadius: theme.borderRadii.xs,
    position: 'relative',
    overflow: 'hidden',
  },

  progressBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 4,
    backgroundColor: theme.colors.alertRed,
  },
});
